import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

import { CognitoService } from "../../services/cognito.service";
import { RBACService } from "../../services/rbac.service";
import { encryptStorage } from "../../utils/storage/storage";

@Component({
  selector: "app-menu",
  templateUrl: "./menu.component.html",
  styleUrls: ["./menu.component.scss"],
})
export class MenuComponent implements OnInit {
  envAmbiente: any;
  isOpened: boolean = false;
  rbacService: RBACService;

  constructor(private cognitoService: CognitoService) {}

  ngOnInit() {
    this.rbacService = new RBACService(encryptStorage.getItem("@rbac", true));
    this.openNav();
    this.makeDropDown();
    this.envAmbiente = environment;
    this.isOpened = false;
  }

  closeNav() {
    this.isOpened = false;
  }

  openNav() {
    this.isOpened = true;
  }

  userHasAcessToResource(codeAccess: number): Boolean {
    return this.rbacService.userHasAcessToResource(codeAccess);
  }

  logout() {
    this.cognitoService.logout();
  }

  //PRIVATE
  private makeDropDown(): void {
    const dropdown: HTMLCollectionOf<Element> =
      document.getElementsByClassName("dropdown-btn");

    for (let i = 0; i < dropdown.length; i++) {
      const element = dropdown[i] as HTMLElement;
      element.addEventListener("click", function () {
        this.classList.toggle("active");
        const dropdownContent = this.nextElementSibling as HTMLElement | null;
        if (dropdownContent) {
          dropdownContent.style.display =
            dropdownContent.style.display === "block" ? "none" : "block";
        }
      });
    }
  }
}
